import { jwtDecode } from 'jwt-decode' // ✅ correct

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/admin': [
    'SuperAdmin',
    'Admin'
  ]
}

export default {
  token: state => state.token,
  passthrough: state => state.passthrough,
  user: state => state.token ? jwtDecode(state.token) : {},
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) { return true }
      if (state.roles && state.roles.length) {
        return state.roles.some(r => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  userProfile: state => state.userProfile,
  userToken: state => state.userToken,
  userInfo: state => state.userInfo,
  roles: state => state.roles,
  primaryRole: (state) => {
    let _role = ''
    for (let role of state.roles) {
      if (role === 'InShopTech' || role === 'DiagCoord') {
        _role = 'Tech'
        break
      } else if (role === 'MasterTech') {
        _role = 'MasterTech'
        break
      } else if (role === 'Dispatch') {
        _role = 'Dispatch'
        break
      }
    }
    return _role
  },
  businessUsers: state => state.businessUsers,
  isLogout: state => state.isLogout,
  demoMode: state => state.demoMode,
  // language: state => state.userInfo?.language || 'en',
  language: state => state.language || 'en',
  solution: state => state.solution,
  isLogging: state => state.isLogging,
  showLog: state => state.showLog,
  log: state => state.log,
  systemLog: state => state.systemLog,
  languages: state => state.languages,
  notificationToken: state => state.notificationToken,
  mahleCoinBalance: state => state.mahleCoinBalance,
  mahleDiagnosticLicenseStatus: state => state.mahleDiagnosticLicenseStatus,
  mahleApiErrorMsg: state => state.mahleApiErrorMsg,
  userIsMahle: state => state.userIsMahle,
  termAndConditionsUIMessage: state => state.termAndConditionsUIMessage,
  isRagOnly: state => {
    return state.isRagOnly || false
  },
  showRag: state => {
    return state.showRag || false
  },
  fullUserData: state => {
    return state.fullUserData || null
  },
  isAuthInitialized: (state) => state.authInitialized,
  configuration: (state) => state.configuration,
  bootstrapped: (state) => state.bootstrapped,
  chatIdentity: (s) => s.chatAs,
  hasChatIdentity: (s) => !!s.chatAs,
  chatIdentityEmail: (s) => s.chatAs?.email || s.userProfile?.email || '',
  chatIdentityNickname: (s) => s.chatAs?.nickname ?? null,
  chatAs: (state) => state.chatAs,
  communicationIdentity: (state) => {
    // Preferred: selected contact
    if (state.chatAs?.email) return state.chatAs

    // Next: userInfo (if your app uses this as contact)
    if (state.userInfo?.email) return state.userInfo

    // Fallback: logged-in user
    return state.userProfile || null
  }
}
